export const DEFAULT_COUNTRY_CODE = "91";

// One entry per dial code, since the backend stores only the dial code
export const COUNTRY_CODES = [
  { code: "91", name: "India" },
  { code: "1", name: "USA / Canada" },
  { code: "44", name: "United Kingdom" },
  { code: "971", name: "UAE" },
  { code: "966", name: "Saudi Arabia" },
  { code: "974", name: "Qatar" },
  { code: "965", name: "Kuwait" },
  { code: "968", name: "Oman" },
  { code: "973", name: "Bahrain" },
  { code: "61", name: "Australia" },
  { code: "64", name: "New Zealand" },
  { code: "65", name: "Singapore" },
  { code: "60", name: "Malaysia" },
  { code: "66", name: "Thailand" },
  { code: "62", name: "Indonesia" },
  { code: "63", name: "Philippines" },
  { code: "84", name: "Vietnam" },
  { code: "852", name: "Hong Kong" },
  { code: "86", name: "China" },
  { code: "81", name: "Japan" },
  { code: "82", name: "South Korea" },
  { code: "94", name: "Sri Lanka" },
  { code: "977", name: "Nepal" },
  { code: "975", name: "Bhutan" },
  { code: "880", name: "Bangladesh" },
  { code: "92", name: "Pakistan" },
  { code: "93", name: "Afghanistan" },
  { code: "960", name: "Maldives" },
  { code: "230", name: "Mauritius" },
  { code: "49", name: "Germany" },
  { code: "33", name: "France" },
  { code: "39", name: "Italy" },
  { code: "34", name: "Spain" },
  { code: "31", name: "Netherlands" },
  { code: "32", name: "Belgium" },
  { code: "41", name: "Switzerland" },
  { code: "43", name: "Austria" },
  { code: "46", name: "Sweden" },
  { code: "47", name: "Norway" },
  { code: "45", name: "Denmark" },
  { code: "358", name: "Finland" },
  { code: "353", name: "Ireland" },
  { code: "351", name: "Portugal" },
  { code: "30", name: "Greece" },
  { code: "48", name: "Poland" },
  { code: "7", name: "Russia / Kazakhstan" },
  { code: "90", name: "Turkey" },
  { code: "972", name: "Israel" },
  { code: "20", name: "Egypt" },
  { code: "27", name: "South Africa" },
  { code: "234", name: "Nigeria" },
  { code: "254", name: "Kenya" },
  { code: "255", name: "Tanzania" },
  { code: "256", name: "Uganda" },
  { code: "55", name: "Brazil" },
  { code: "52", name: "Mexico" },
  { code: "54", name: "Argentina" },
  { code: "57", name: "Colombia" },
  { code: "56", name: "Chile" },
];

export const isIndiaCode = (countryCode) =>
  !countryCode || String(countryCode).trim() === DEFAULT_COUNTRY_CODE;

// Mirrors the backend MobileNumberValidator: India is 10 digits, others 6 to 15
export const getMobileError = (countryCode, mobileNumber) => {
  const number = (mobileNumber ?? "").trim();
  if (!/^[0-9]+$/.test(number)) {
    return "Invalid mobile number";
  }
  if (isIndiaCode(countryCode)) {
    return number.length === 10 ? "" : "Mobile Number should be 10 digits";
  }
  return number.length >= 6 && number.length <= 15
    ? ""
    : "Mobile Number should be 6 to 15 digits";
};

export const isValidMobile = (countryCode, mobileNumber) =>
  !getMobileError(countryCode, mobileNumber);

// Used by login / OTP / forgot password where the country is not known up front
export const MOBILE_ANY_COUNTRY_ERROR = "Phone Number must be 6 to 15 digits";
export const isValidMobileAnyCountry = (value) =>
  /^[0-9]{6,15}$/.test((value ?? "").trim());

export const getMobileLabel = (countryCode) =>
  isIndiaCode(countryCode) ? "10 digit Mobile Number" : "Mobile Number";

export const getOtpChannel = (countryCode) =>
  isIndiaCode(countryCode) ? "SMS" : "WhatsApp";

// "+91 9876543210" for India, "+44 7911123456 (United Kingdom)" for others
export const formatMobileWithCountry = (countryCode, mobileNumber) => {
  if (!mobileNumber) {
    return null;
  }
  const code = isIndiaCode(countryCode)
    ? DEFAULT_COUNTRY_CODE
    : String(countryCode).trim();
  if (code === DEFAULT_COUNTRY_CODE) {
    return `+${code} ${mobileNumber}`;
  }
  const country = COUNTRY_CODES.find((c) => c.code === code);
  return `+${code} ${mobileNumber}${country ? ` (${country.name})` : ""}`;
};
